import styled from 'styled-components'

const StyledHomeView = styled.div`
  .page-content {
    max-width: 680px;
    margin: 0 auto;
    width: 100%;
    padding: 40px 20px;
    box-sizing: border-box;
  }
`

export default StyledHomeView
